import { cls } from "@wss/cls";
import { logException } from "@wss/error-tracking";
import React from "react";

interface NavigationProps {
  children: React.ReactNode | React.ReactNode[];
}

const Navigation = ({ children }: NavigationProps) => {
  return <div className="quicklinks-banner__nav-block">{children}</div>;
};

export interface ButtonLinkProps {
  className?: string;
  area: string;
  title?: string | undefined;
  text: string | React.ReactNode;
  shortText?: string | React.ReactNode;
  show?: boolean;
  onClick?: (event: React.MouseEvent) => void;
}

Navigation.Button = ({
  area,
  title,
  text,
  shortText,
  show = true,
  onClick,
}: ButtonLinkProps) => {
  const handleClick = (event: React.MouseEvent) => {
    event.preventDefault();
    onClick?.(event);

    const elementToJumpTo = document.querySelector(area);

    if (!elementToJumpTo) {
      const error = new Error(
        `Unable to scroll to element via selector, ${area}. Please ensure the element is in the DOM.`,
      );
      logException(error);
      throw error;
    }
    elementToJumpTo.scrollIntoView();
  };

  return (
    <>
      {show && (
        <li className="inline">
          <button
            className={cls(
              "quicklinks-banner__nav-item",
              "bg-transparent",
              "border-b-[3px]",
              "border-solid",
              "border-t-0",
              "border-x-0",
              "h-9",
              "inline-flex",
              "items-center",
              "scroll-anchor",
              "text-gray-800",
              "hover:border-green-500",
              "hover:border-b-[3px]",
              "hover:border-solid",
            )}
            title={title || (typeof text === "string" ? text : "")}
            onClick={handleClick}
            type="button"
            aria-label={text?.toString()}
          >
            {shortText ? (
              <>
                <span className="hidden lg:block">{text}</span>
                <span className="lg:hidden">{shortText}</span>
              </>
            ) : (
              <span>{text}</span>
            )}
          </button>
        </li>
      )}
    </>
  );
};

export default Navigation;
